export const openShareUrl = (url?: string) => {
  url && window.open(url, '_blank');
};
